import { axiosInstance } from 'src/store/server/client';
import type { APICommonResponse } from 'src/types/common.types';
import { checkLogin } from 'src/utils/auth';

import type {
  GetMintingInitRequest,
  GetMintingInitResponse,
  GetOriginalsInitRequest,
  GetOriginalsInitResponse,
  GetOriginalsListRequest,
  GetOriginalsListResponse,
  SetOriginalsFavorRequest,
} from './originals.dto';

export const originalsService = {
  // 오리지널스 초기 정보 조회
  getOriginalsInit: async ({
    originals_name_list,
  }: GetOriginalsInitRequest): Promise<APICommonResponse<GetOriginalsInitResponse>> => {
    return axiosInstance.market.public.get('/originals/init', {
      params: {
        originals_name_list,
      },
    });
  },

  // 민팅 초기 정보 조회
  getMintingInit: async ({
    minting_name_list,
  }: GetMintingInitRequest): Promise<APICommonResponse<GetMintingInitResponse>> => {
    return axiosInstance.market.public.get('/card/init', {
      params: { minting_name_list },
    });
  },

  // 오리지널스 목록 조회
  getOriginalsList: async ({
    cursor,
    size,
    status,
  }: GetOriginalsListRequest): Promise<APICommonResponse<GetOriginalsListResponse>> => {
    return (checkLogin() ? axiosInstance.market.private : axiosInstance.market.public).get('/originals', {
      params: {
        cursor,
        size,
        ...(status && { status }),
      },
    });
  },

  // 오리지널스 좋아요
  setOriginalsFavor: async (params: SetOriginalsFavorRequest): Promise<APICommonResponse<null>> => {
    return axiosInstance.market.private.post('/main/originals/favor', params);
  },
};
